class statisticsInvStateListCtrl {
    constructor($scope, logger, httpRequest, $state, treeSelectService) {
        // 字典数据
        $scope.dictData = {}
        const typecodeArrStr = '["inv_type","source_object"]'
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })

        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                invType: '',
                invoiceDateMax: initDate(),
                invoiceDateMin: initDate(),
                orgIdList: [JSON.parse(localStorage.user_info).user.currentOrgId],
                saleIdList: [],
                ukeyIdList: [],
                accessToken: localStorage.id_token,
            },
        }
        $scope.reset = function () {
            $scope.param.param = {
                invType: '',
                invoiceDateMax: initDate(),
                invoiceDateMin: initDate(),
                orgIdList: [JSON.parse(localStorage.user_info).user.currentOrgId],
                saleIdList: [],
                ukeyIdList: [],
                accessToken: localStorage.id_token,
            }
            $scope.queryOrgConfig.defaultSelect = defaultOrg
            $scope.querySaleConfig.defaultSelect = []
        } // 下拉机构组件配置
        $scope.queryOrgConfig = {
            queryName: 'orgName',
            queryKey: 'orgId',
            queryType: 'Flater',
            parentIdName: 'parentOrgId',
            multiple: true,
            parentId: 0,
            defaultSelect: [],
        }
        // 下拉销方
        $scope.querySaleConfig = {
            queryName: 'saleName',
            queryKey: 'saleId',
            queryType: 'Flater',
            parentIdName: 'parentSaleId',
            multiple: true,
            parentId: 0,
            defaultSelect: [],
        }
        // $scope.reset()
        $scope.datePickerConfig = {
            format: 'yyyy-mm',
            minView: 3,
            startView: 3,
        }
        $scope.customizedConfig = {
            version: 1.01,
            queryConfig: [
                {
                    label: '所属月份起止',
                    selected: true,
                    default: true,
                }, {
                    label: '销方名称',
                    selected: true,
                    default: true,
                }, {
                    label: '发票种类',
                    selected: false,
                    default: false,
                }, {
                    label: '开票机构筛选',
                    selected: false,
                    default: false,
                }, {
                    label: '发票来源',
                    selected: true,
                    default: true,
                },],
        }
        // 更新时间
        $scope.latestUpdateTime = ''
        httpRequest.get_queryStatTime({ reportId: 1 }).then((res) => {
            $scope.latestUpdateTime = res.data.value.lastStatTime
            $scope.dataBeginDate = res.data.value.dataBeginDate
        })


        $scope.orgList = [] // 机构
        $scope.ukeyList = [] // 开票点
        $scope.saleList = [] // 销方

        // 时间格式初始化
        function initDate(month, year) {
            const date = new Date()
            const y = year || date.getFullYear()
            let m = month || date.getMonth() + 1
            m = m < 10 ? `0${m}` : m
            return `${y}-${m}`
        }
        // 机构变化
        $scope.orgSelectChange = function (v) {
            const orgSelectArr = v
            const orgSelectL = orgSelectArr.length
            if (orgSelectL > 0) {
                $scope.param.param.orgIdList = orgSelectArr.map((item) => item.orgId)
            } else {
                $scope.param.param.orgIdList = []
            }
            $scope.param.param.ukeyIdList = []
            $scope.queryOrgConfig.defaultSelect = v
            httpRequest.post_qryUkeyListOfOrgIds($scope.param.param.orgIdList).then((res) => {
                if (res.data.success) {
                    $scope.ukeyList = treeSelectService(res.data.value, 'ukeyId', 'ukeyName')
                    $scope.ukeyListArr = treeSelectService(res.data.value, 'ukeyId', 'ukeyName') // 当前开票点
                }
            })
        }


        // 销方变化
        $scope.saleSelectChange = function (v) {
            const saleSelectArr = v
            const saleSelectL = saleSelectArr.length
            if (saleSelectL > 0) {
                $scope.param.param.saleIdList = saleSelectArr.map((item) => item.saleId)
            } else {
                $scope.param.param.saleIdList = []
            }
        }
        let defaultOrg = []
        httpRequest.get_getUserOrgList().then((res) => {
            if (res.data.success) {
                $scope.orgList = res.data.value
                $scope.queryOrgConfig.defaultSelect = res.data.value.filter((item) => item.orgId === JSON.parse(localStorage.user_info).user.currentOrgId)
                defaultOrg = res.data.value.filter((item) => item.orgId === JSON.parse(localStorage.user_info).user.currentOrgId)
                // 返回机构名称
                $scope.fliterOrgName = function (id) {
                    if (id === null) {
                        return id
                    }
                    if (res.data.value === null) {
                        return id
                    }
                    const fliterUkeyNameArr = res.data.value.filter((item) => item.orgId === id)
                    if (fliterUkeyNameArr.length > 0) {
                        return fliterUkeyNameArr[0].orgName
                    }
                    return id
                }
                // 返回销方数组
                const orgIdList = res.data.value.map((item) => item.orgId)
                queryInfo()
                // 销方
                if (orgIdList.length > 0) {
                    httpRequest.post_getSaleInfoListByOrgIds(orgIdList).then((res) => {
                        $scope.saleList = treeSelectService(res.data, 'saleId', 'saleName')
                    })
                }
            }
        })


        // 返回开票点名称
        $scope.ukeyListArr = []
        $scope.fliterUkeyName = function (id) {
            if (id === null) {
                return id
            }
            if ($scope.ukeyListArr === null || $scope.ukeyListArr.length === 0) {
                return id
            }
            const fliterUkeyNameArr = $scope.ukeyListArr.filter((item) => item.id === id)
            if (fliterUkeyNameArr.length > 0) {
                return fliterUkeyNameArr[0].ukeyName
            }
            return id
        }


        // 导出
        $scope.exportInvoic = function () {
            httpRequest.get_exportInvoiceStatusToXLS($scope.param.param)
        }


        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数


        function countResult(list) {
            let preRow = list.shift()
            const counts = {}
            counts[preRow.saleCreditCode] = 1
            // 同税号同机构下月份数
            counts[`${preRow.saleCreditCode}${preRow.invoiceOrgId}`] = 1
            // 同税号同机构同月份下发票种类数
            counts[`${preRow.saleCreditCode}${preRow.invoiceOrgId}${preRow.invoiceMonth}`] = 1
            do {
                const listItem = list.shift()
                if (listItem.saleCreditCode === preRow.saleCreditCode) {
                    if (listItem.invoiceOrgId !== preRow.invoiceOrgId) {
                        // 该税号下机构数加1
                        counts[listItem.saleCreditCode] += 1
                        // 该机构下月份数 初始化 1
                        counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] = 1
                        // 该月份下发票种类数初始化 1
                        counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                    } else if (listItem.invoiceMonth !== preRow.invoiceMonth) {
                        // month + 1
                        counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] += 1
                        // 该月份下发票种类数初始化 1
                        counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                    } else if (listItem.invType !== preRow.invType) {
                        counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] += 1
                    }
                } else {
                    // 税号下机构数
                    counts[listItem.saleCreditCode] = 1
                    // 同税号同机构下月份数
                    counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] = 1
                    // 同税号同机构同月份下发票种类数
                    counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                }
                preRow = listItem
            } while (list.length > 0)
            return counts
        }


        function countResultWhileNoOrg(list) {
            let preRow = list.shift()
            const counts = {}
            // 同税号同机构下月份数
            counts[preRow.saleCreditCode] = 1
            // 同税号同机构同月份下发票种类数
            counts[`${preRow.saleCreditCode}${preRow.invoiceMonth}`] = 1
            do {
                const listItem = list.shift()
                if (listItem.saleCreditCode === preRow.saleCreditCode) {
                    if (listItem.invoiceMonth !== preRow.invoiceMonth) {
                        // month + 1
                        counts[`${listItem.saleCreditCode}`] += 1
                        // 该月份下发票种类数初始化 1
                        counts[`${listItem.saleCreditCode}${listItem.invoiceMonth}`] = 1
                    } else if (listItem.invType !== preRow.invType) {
                        counts[`${listItem.saleCreditCode}${listItem.invoiceMonth}`] += 1
                    }
                } else {
                    // 同税号同机构下月份数
                    counts[listItem.saleCreditCode] = 1
                    // 同税号同机构同月份下发票种类数
                    counts[`${listItem.saleCreditCode}${listItem.invoiceMonth}`] = 1
                }
                preRow = listItem
            } while (list.length > 0)
            return counts
        }

        function getRowsapns(list) {
            let preRow = list.shift()
            const rowspan = {}
            rowspan[preRow.saleCreditCode] = 1
            // 同税号同机构下月份数
            rowspan[`${preRow.saleCreditCode}${preRow.invoiceOrgId}`] = 1
            // 同税号同机构同月份下发票种类数
            rowspan[`${preRow.saleCreditCode}${preRow.invoiceOrgId}${preRow.invoiceMonth}`] = 1
            while (list.length > 0) {
                const listItem = list.shift()
                if (!$scope.isShowThisRow(listItem)) {
                    continue
                }
                if (listItem.saleCreditCode === preRow.saleCreditCode) {
                    rowspan[listItem.saleCreditCode] += 1
                    if (listItem.invoiceOrgId === preRow.invoiceOrgId) {
                        rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] += 1
                        if (listItem.invoiceMonth === preRow.invoiceMonth) {
                            rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] += 1
                        } else {
                            rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                        }
                    } else {
                        rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] = 1
                        rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                    }
                } else {
                    // 税号下机构数
                    rowspan[listItem.saleCreditCode] = 1
                    // 同税号同机构下月份数
                    rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] = 1
                    // 同税号同机构同月份下发票种类数
                    rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                }
                preRow = listItem
            }
            return rowspan
        }

        $scope.getMonthRowspan = function getMonthRowspan(item) {
            return $scope.rowspans[`${item.saleCreditCode}${item.invoiceOrgId}${item.invoiceMonth}`]
        }

        $scope.getOrgRowspan = function getOrgRowspan(item) {
            return $scope.rowspans[`${item.saleCreditCode}${item.invoiceOrgId}`]
        }

        $scope.getCreditRowspan = function getCreditRowspan(item) {
            return $scope.rowspans[item.saleCreditCode]
        }

        $scope.isShowThisRow = function isShowThisRow(item) {
            let orgCount
            let monthCount
            let invTypeCount
            if ($scope.showOrgCol) {
                orgCount = $scope.counts[item.saleCreditCode]
                monthCount = $scope.counts[`${item.saleCreditCode}${item.invoiceOrgId}`]
                invTypeCount = $scope.counts[`${item.saleCreditCode}${item.invoiceOrgId}${item.invoiceMonth}`]
            } else {
                monthCount = $scope.counts[`${item.saleCreditCode}`]
                invTypeCount = $scope.counts[`${item.saleCreditCode}${item.invoiceMonth}`]
            }

            if (item.invType === '9999999' && invTypeCount === 2) {
                return false
            }
            if (orgCount === 2 && item.invoiceOrgId === '9999999') {
                return false
            }
            // 只选了一个月不显示月小计行
            if (monthCount === 2 && item.invoiceMonth === '9999999') {
                return false
            }
            // 1.不选机构按税号统计 2.只选择一个月
            if (monthCount === 2 && !$scope.showOrgCol && item.invoiceMonth === '9999999') {
                return false
            }
            return true
        }

        $scope.isShowThisCredit = function isShowThisCredit(item, index) {
            if (index === 0) {
                return true
            }
            const preRow = $scope.listData[index - 1]
            return preRow.saleCreditCode !== item.saleCreditCode
        }
        $scope.isShowThisOrg = function isShowThisOrg(item, index) {
            if (!$scope.showOrgCol) {
                return false
            }
            if (index === 0) {
                return true
            }
            const preRow = $scope.listData[index - 1]
            return preRow.saleCreditCode !== item.saleCreditCode
                || preRow.invoiceOrgId !== item.invoiceOrgId
        }

        $scope.isShowThisMonth = function isShowThisMonth(item, index) {
            if (index === 0) {
                return true
            }
            const preRow = $scope.listData[index - 1]
            if ($scope.showOrgCol) {
                return preRow.saleCreditCode !== item.saleCreditCode
                    || preRow.invoiceOrgId !== item.invoiceOrgId
                    || preRow.invoiceMonth !== item.invoiceMonth
            }
            return preRow.saleCreditCode !== item.saleCreditCode
                || preRow.invoiceMonth !== item.invoiceMonth
        }
        // let isSearch = false
        // $scope.$watch('param', () => {
        //     isSearch = false
        // }, true)
        // $scope.$on('$stateChangeStart', (e, toState) => {
        //     if (toState.name.indexOf('statistics.outputStatistics.statisticsInvState') != -1) {
        //         isSearch && sessionStorage.setItem('invStateParam', JSON.stringify($scope.param))
        //     }
        // })
        function queryInfo() {
            const invoiceDateMaxTmp = new Date($scope.param.param.invoiceDateMax)
            const invoiceDateMinTmp = new Date($scope.param.param.invoiceDateMin)
            if (overOneYear(invoiceDateMaxTmp, invoiceDateMinTmp)) {
                logger.logError('[所属月份起止]起始结束时间跨度不能超过一年')
                return
            }
            if ($scope.ukeyList.length > 0) {
                $scope.ukeyListArr = treeSelectService($scope.ukeyList, 'ukeyId', 'ukeyName')
            }

            if ($scope.param.param.orgIdList.length !== 0) {
                $scope.showOrgCol = true
            } else {
                $scope.showOrgCol = false
            }
            $scope.saleGrade = saleGradeFn()
            $scope.orgGrade = orgGradeFn()
            $scope.param = sessionStorage.invStateParam ? JSON.parse(sessionStorage.invStateParam) : $scope.param
            httpRequest.post_qryBiInvoiceStatusList($scope.param).then((res) => {
                const listData = res.data.value
                $scope.lastParam = { ...$scope.param.param }
                $scope.listData = listData
                $scope.param.pageNum = res.data.value.pageNum
                if (listData.length === 0) {
                    return
                }
                if ($scope.showOrgCol) {
                    $scope.counts = countResult(listData.slice())
                } else {
                    $scope.counts = countResultWhileNoOrg(listData.slice())
                }
                $scope.rowspans = getRowsapns(listData.slice())
            })
        }

        function overOneYear(max, min) {
            const dateMaxTmp = new Date(max)
            const dateMinTmp = new Date(min)

            const dateMaxYear = dateMaxTmp.getFullYear()
            const dateMaxMonth = dateMaxTmp.getMonth()

            const dateMinYear = dateMinTmp.getFullYear()
            const dateMinMonth = dateMinTmp.getMonth()

            return (dateMaxYear - dateMinYear > 1) || (dateMaxYear - dateMinYear === 1) && (dateMaxMonth - dateMinMonth > -1)
        }

        // 是否展示机构
        $scope.showOrgCol = false
        // 是否展示开票点
        $scope.showUkeyRow = false
        // 销方粒度
        $scope.saleGrade = true
        function saleGradeFn() {
            return $scope.param.param.orgIdList.length === 0 && $scope.param.param.ukeyIdList.length === 0
        }
        // 机构粒度
        $scope.orgGrade = false
        function orgGradeFn() {
            return $scope.param.param.orgIdList.length > 0
        }

        $scope.toOrgIdDetailPage = function toOrgIdDetailPage(item) {
            if (!$scope.orgGrade) {
                return
            }
            localStorage.setItem(
                'stateStatisticsDetail',
                JSON.stringify({
                    invType: $scope.lastParam.invType,
                    invoiceDateMax: $scope.lastParam.invoiceDateMax,
                    invoiceDateMin: $scope.lastParam.invoiceDateMin,
                    orgId: item.invoiceOrgId,
                    orgName: item.orgName,
                    saleCreditCode: item.saleCreditCode,
                    saleName: item.saleName,
                }),
            )
            $state.go('statistics.outputStatistics.statisticsInvState.detail')
        }
        $scope.searchlist = function () { // 点击搜索发起查询
            sessionStorage.setItem('invStateParam', JSON.stringify($scope.param))
            queryInfo()
        }
    }
}
statisticsInvStateListCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$state', 'treeSelectService']
export default statisticsInvStateListCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsInvState/statisticsInvStateListCtrl.js